import { cn } from "tailwind-variants";
import { calculateSizes } from "./utils";
import { useDtfStore } from "../store";
import { renderList } from "common/vue/render-list";
import "./Styles.scss";

export default function JerseyNumbersStyle({ ...restProps }) {
  const options = [
    {
      label: "Solid Numbers",
      value: "solid"
    },
    {
      label: "Outline Numbers",
      value: "outline"
    },
    {
      label: "Promesh",
      value: "promesh"
    },
    {
      label: "Soccer League",
      value: "soccer-league"
    },
    {
      label: "Octin Sports",
      value: "octin-sports"
    },
    {
      label: "Rueckwarzsalto",
      value: "rueckwarzsalto"
    },
    {
      label: "Varsity Team",
      value: "varsity-team"
    }
  ];

  const store = useDtfStore();

  function letterNumberArtwork() {
    return store.letterNumberArtwork;
  }

  function handleSelect(option) {
    const style = option.value;
    const sizes = calculateSizes({
      ...letterNumberArtwork(),
      style
    });
    store.updateArtworkValues({
      index: 0,
      style,
      sizes
    });
    if (Object.keys(sizes).length) {
      store.getArtworksPricing();
    }
    store.updateJerseyNumberPdpDates();
  }

  return (
    <div {...restProps} className={cn("jersey-numbers-style", restProps.className)}>
      {renderList(options, option => (
        <div
          className={cn({
            "jersey-numbers-style__item": true,
            "jersey-numbers-style__item--selected": option.value === letterNumberArtwork().style
          })}
          key={option.value}
          onClick={() => {
            handleSelect(option);
          }}
          data-testid="styles-div"
        >
          <div
            className={cn({
              "jersey-numbers-style__text": true,
              [`jersey-numbers-style__text--${option.value}`]: true
            })}
          >
            {" "}
            12345
            <br />
            67890{" "}
          </div>
          <span className="jersey-numbers-style__label">{option.label}</span>
        </div>
      ))}
    </div>
  );
}
